import { AllocateSingleId } from "../../AllocateId";
import { GetMasterTableEntries } from "../../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../../Post";


const MasterTableName = "GAAProjectSpaceTypeMaster";
const FetchRequestType = "GAAProjectSpaceTypeFetchRequest";

export const SaveProjectSpaceType = async (ref, payload) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, []);
};

export const GetProjectSpaceTypeList = async () => {
  let payload = { Refs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  //  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

export const GetProjectSpaceType = async (Ref) => {
  let payload = { GAAProjectSpaceTypeRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const DeleteProjectSpaceType = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetGAAProjectSpaceTypeListByProject = async (GAAProjectRef) => {
  let payload = { GAAProjectRefs: [GAAProjectRef]};
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  return result;
};
